
import { useEffect, useState } from "react";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";

import firebaseApp from "../firebase";


const useFcm = (enabled = false) => {
  const [fcmToken, setFcmToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    if (!enabled) return;

    let unsubscribe;
    let active = true;

    const setupFcm = async () => {
      try {
        setLoading(true);
        setError(null);

        if (
          typeof Notification === "undefined" ||
          !("serviceWorker" in navigator) ||
          !(await isSupported())
        ) {
          throw new Error("Firebase Messaging is not supported");
        }

        let permission = Notification.permission;

        if (permission === "default") {
          permission = await Notification.requestPermission();
        }

        if (permission !== "granted") {
          return;
        }

        const registration =
          await navigator.serviceWorker.register(
            "/firebase-messaging-sw.js"
          );

        const messaging = getMessaging(firebaseApp);

        unsubscribe = onMessage(messaging, async (payload) => {
          if (!active) return;

          const title =
            payload.notification?.title ||
            payload.data?.title ||
            "7 Trade";

          const body =
            payload.notification?.body ||
            payload.data?.body ||
            "";

          const ticketId =
            payload.data?.ticket_id ||
            payload.data?.ticketId;

          setNotification(payload);

          await registration.showNotification(title, {
            body,
            icon: "/favicon.ico",
            data: {
              ...payload.data,
              ticket_id: ticketId,
            },
          });
        });

        if (!active) {
          unsubscribe();
          return;
        }

        const token = await getToken(messaging, {
          vapidKey: "BBh6otB2xM_nHSG3aYax56S0_EeBsv08pinNnHhPhdwZ2IiUlsDfPy0Ni4v4MONP4twV1EcopZg38reifxfbedQ",
          serviceWorkerRegistration: registration,
        });

        if (!token || !active) return;

        setFcmToken(token);

      } catch (err) {
        if (active) {
          console.error("FCM setup failed:", err);
          setError(err);
        }
      } finally {
        if (active) setLoading(false);
      }
    };

    setupFcm();

    return () => {
      active = false;
      unsubscribe?.();
    };
  }, [enabled]);

  return {
    fcmToken,
    loading,
    error,
    notification,
  };
};

export default useFcm;
